import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import PlaceTrainerSelect from "../Auth/placeTrainerSelect";
import { Dots } from "../Loader/loader";

const TODAY = new Date().toISOString().slice(0, 10);

// Shown instead of the account while the registration is unfinished (for example after the first
// Google sign-in). The member can leave and come back — the same step is shown until it is done.
const CompleteRegistration = () => {
  const { user, updateProfile, logout } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    firstname: user.firstname || "",
    surname: user.surname || "",
    patronymic: user.patronymic || "",
    date_of_birth: user.date_of_birth || "",
    sex: user.sex || "",
    address: user.address || "",
    phone: user.phone || "",
    email: user.email || "",
    place_id: user.place ? String(user.place.id) : "",
    trainer_id: user.trainer ? String(user.trainer.id) : "",
  });
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const handlePlaceTrainer = (changes) => {
    setForm((prev) => ({ ...prev, ...changes }));
    setErrors((prev) => ({ ...prev, place_id: undefined, trainer_id: undefined }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");
    setErrors({});
    setSaving(true);
    try {
      await updateProfile(form);
    } catch (err) {
      if (err.response?.status === 422) {
        setErrors(err.response.data.errors || {});
        setFormError("Ստուգեք լրացված տվյալները։");
      } else {
        setFormError("Չհաջողվեց պահպանել։ Փորձեք կրկին։");
      }
    } finally {
      setSaving(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const fieldClass = (name) => `auth-field${errors[name] ? " invalid" : ""}`;
  const fieldError = (name) => errors[name] && <span className="auth-error">{errors[name][0]}</span>;

  return (
    <div className="auth-page">
      <div className="auth-card wide">
        <h2 className="auth-title">Լրացրեք գրանցումը</h2>
        <p className="auth-muted" style={{ textAlign: "center" }}>
          Անձնական էջը կլինի հասանելի, երբ լրացնեք ստորև նշված տվյալները։
        </p>
        <form className="auth-form" onSubmit={handleSubmit} noValidate>
          {formError && <div className="auth-alert">{formError}</div>}

          <div className="auth-row">
            <div className={fieldClass("firstname")}>
              <label htmlFor="firstname">Անուն</label>
              <input id="firstname" name="firstname" value={form.firstname} onChange={handleChange} />
              {fieldError("firstname")}
            </div>
            <div className={fieldClass("surname")}>
              <label htmlFor="surname">Ազգանուն</label>
              <input id="surname" name="surname" value={form.surname} onChange={handleChange} />
              {fieldError("surname")}
            </div>
          </div>

          <div className={fieldClass("patronymic")}>
            <label htmlFor="patronymic">Հայրանուն</label>
            <input id="patronymic" name="patronymic" value={form.patronymic} onChange={handleChange} />
            {fieldError("patronymic")}
          </div>

          <div className="auth-row">
            <div className={fieldClass("date_of_birth")}>
              <label htmlFor="date_of_birth">Ծննդյան ամսաթիվ</label>
              <input id="date_of_birth" name="date_of_birth" type="date" min="1930-01-01" max={TODAY} value={form.date_of_birth} onChange={handleChange} />
              {fieldError("date_of_birth")}
            </div>
            <div className={fieldClass("sex")}>
              <label htmlFor="sex">Սեռ</label>
              <select id="sex" name="sex" value={form.sex} onChange={handleChange}>
                <option value="">Ընտրեք սեռը</option>
                <option value="Արական">Արական</option>
                <option value="Իգական">Իգական</option>
              </select>
              {fieldError("sex")}
            </div>
          </div>

          <div className="auth-row stack">
            <div className={fieldClass("address")}>
              <label htmlFor="address">Բնակության հասցե</label>
              <input id="address" name="address" value={form.address} onChange={handleChange} />
              {fieldError("address")}
            </div>
            <div className={fieldClass("phone")}>
              <label htmlFor="phone">Հեռախոս</label>
              <input id="phone" name="phone" type="tel" value={form.phone} onChange={handleChange} />
              {fieldError("phone")}
            </div>
          </div>

          <PlaceTrainerSelect
            placeId={form.place_id}
            trainerId={form.trainer_id}
            onChange={handlePlaceTrainer}
            errors={errors}
          />

          <button className="auth-btn" type="submit" disabled={saving}>
            {saving ? <Dots /> : "Ավարտել գրանցումը"}
          </button>
        </form>
        <p className="auth-switch">
          <button type="button" className="link-btn" onClick={handleLogout}>
            Ելք
          </button>
        </p>
      </div>
    </div>
  );
};

export default CompleteRegistration;
